export enum DocTypeEnum {
    NONE = -1,
    OTHER = 0,
    DOC = 1,//Only PDF
    IMAGE = 2
}